import { BooleanRule } from '@/classes/rules/BooleanRule';
import { ObjectRule } from '@/classes/rules/ObjectRule';
import { ScenarioSizingExt } from '@/classes/scenario/sizing/ScenarioSizingExt';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { EnumRule } from '@/classes/rules/EnumRule';
import { SizingAlgorithmRef } from '@/dto/scenario/sizing/SizingReference';
import { FieldUsage } from '@/classes/rules/FieldUsage';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';

// SIZINGRULES =========================================================
export const buildSizingRules = () => new ObjectRule<ScenarioSizingExt>('sizing', [

  new EnumRule('algorithmRef', SizingAlgorithmRef)
    .withDefaultValue(scenario => {
      if (scenario && scenario.hasBattery) {
        return new DefaultValue(SizingAlgorithmRef.algo_v3_hybrid);
      }
      return new DefaultValue(SizingAlgorithmRef.algo_v3);
    })
    .withFilterOptions(([key, value], scenario) => {
      if (scenario?.isMultigenset()) {
        return key === SizingAlgorithmRef.algo_multi_genset;
      }
      const hasGrid24 = scenario?.hasGrid && (scenario.grid?.hasGrid24);
      if (hasGrid24) {
        return key === SizingAlgorithmRef.algo_v3;
      }
      if (scenario?.hasBattery) {
        return key === SizingAlgorithmRef.algo_v3 || key === SizingAlgorithmRef.algo_v3_hybrid;
      }
      return key === SizingAlgorithmRef.algo_v3;
    })
    .withIsAvailable(scenario => !isRenFranceProject(scenario)),

  new BooleanRule('hasBatteryRange').withRequired(true).withIsAvailable(scenario => scenario.hasBattery || false),

  new MinMaxRule('pvMin', 0, 1000000, 'kwp').withIsAvailable((scenario) => !scenario.hasInjectionType(InjectionModelRef.total_injection)),
  new MinMaxRule('pvMax', 0, 1000000, 'kwp').withIsAvailable((scenario) => !scenario.hasInjectionType(InjectionModelRef.total_injection)),

  new MinMaxRule('batteryMin', 0, 1000000, 'kwh').withIsAvailable(scenario => (scenario.hasBattery && scenario.sizing && scenario.sizing.hasBatteryRange) || false),
  new MinMaxRule('batteryMax', 0, 1000000, 'kwh').withIsAvailable(scenario => (scenario.hasBattery && scenario.sizing && scenario.sizing.hasBatteryRange) || false),
  new MinMaxRule('batteryCapacity', 0, 1000000, 'kwh')
    .withIsAvailable(scenario => (scenario.hasBattery && scenario.sizing && scenario.sizing.hasBatteryRange === false) || false),

  new MinMaxRule('batteryReport', 0, 1000000, 'kwh').withIsAvailable(scenario => scenario.hasBattery || false)
    .withFieldUsage(new FieldUsage({ sizing: false, preSizing: false })),
  new MinMaxRule('pvReport', 0, 1000000, 'kwp')
    .withIsAvailable((scenario) => !scenario.hasInjectionType(InjectionModelRef.total_injection))
    .withFieldUsage(new FieldUsage({ sizing: false, preSizing: false }))
]).withDefaultValue(_ => new DefaultValue(new ScenarioSizingExt()));

function isRenFranceProject(scenario: ScenarioExt): boolean {
  return (scenario.project?.typeRef === ProjectTypeRef.ren_fr_pv_project || scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project) &&
    scenario.hasInjectionType(InjectionModelRef.total_injection);
}
